// ====================================================================================
// a11y module
// ====================================================================================

export const init = () => {
    let attempts = 0;

    const whenComplete = () => {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            document.querySelectorAll(".powermail_submit").forEach((el) => {
                el.addEventListener("keydown", (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.target.click();
                    }
                });
            });
        } else {
            setTimeout(() => whenComplete(), 400);
        }
    };

    whenComplete();
};
